import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { useEffect, useState } from 'react';
import featureRequestDialog from '../../assets/FeatureRequest.png';
import './featureRequest.scss';
import { REPORTISSUE_URL } from '../../constants';
import axios from '../../datasource/axios';
import Spinner from '../../components/shared/spinner.jsx';
import { hideLoader } from '../../datasource/msal';
import { Dialog } from 'primereact/dialog';

export const FeatureRequest = (props : any) => {
    const [featureType, setFeatureType] = useState<any>(null);
    const [featureRequestComment, setFeatureRequestComment] = useState('');
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [successvisible, setSuccessVisible] = useState(false);
    const [failvisible, setFailVisible] = useState(false);
    const [number, setNumber] = useState('');
    const [count, setCount] = useState(1);
    const [message, setMessage] = useState("Unable to create a ticket, please click on Ok to try again.");

    const setSuccessdialogvisibility = () => {
        if (!successvisible) return; setSuccessVisible(false);
        props.handleCallback(false);
    }

    const setFaildialogvisibility = () => {
        if (count < 3) {
            if (count == 2) {
                setMessage("We are having issues creating ticket, Please open ticket manually via AskNow or Please try again later.");
            } else {
                Submit();
            }
            setCount(count + 1);
        }
        else {
            if (!failvisible) return; setFailVisible(false);
            props.handleCallback(false);
        }
    }

    
    const headerSuccessElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Success</span>
        </div>
    );

    const footerSuccessContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={setSuccessdialogvisibility} autoFocus style={{ borderRadius: '12px', backgroundColor: '#3299FF', color: 'white' }} />
        </div>
    );

    const headerFailElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Fail</span>
        </div>
    );

    const footerFailContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={setFaildialogvisibility} autoFocus style={{ borderRadius: '12px', backgroundColor: '#3299FF', color: 'white' }} />
        </div>
    );

    const onFeatureTypeChange = (e: { value: any }) => {
        setFeatureType(e.value);
    };


    useEffect(() => {
        const isFormValid =
        featureType !== null &&
         featureRequestComment !== '';
        setEnableSubmit(isFormValid);
    }, [featureRequestComment, featureType]);

    const Submit = async () => {
        let BASE_URL =  process.env.REACT_APP_API_URI;
        let url = BASE_URL + REPORTISSUE_URL + "?description=" + featureRequestComment + '&shortdescription=' + featureType.name + '&type=' + 'feature';
        const res:any = await new Promise((resolve, reject) => {
          try {
            setShowLoader(true);
             axios
              .postRequest(url)
              .then((res: any) => {
                hideLoader();
                setShowLoader(false);
                resolve(res);
              })
              .catch((err: any) => {
                hideLoader();
                setShowLoader(false);
                resolve(err);
              });
          } catch (error) {
            hideLoader();
            setShowLoader(false);
            reject(error);
          }
        });

        if (res.status == "Success") {
            setNumber(res.data);
            setSuccessVisible(true);
        }
        else{
            setFailVisible(true);
        }
    };

    return (
        <div>
            <h5 className="mb-3" style={{ fontSize: '24px', fontWeight: '600' }}>
                {/* <img src={featureRequestDialog} alt="Feature Request" className="pe-2" style={{ width:'50px'}}/>  */}
                Feature Request
            </h5>
            <Divider />

            {/* <h5 className="mt-3" style={{ fontSize: '20px', fontWeight: '600' }}>
                User Details
            </h5>

            <div className="row mt-3">
                <div className="col-md-6">
                    <h5 style={{ fontSize: '16px', fontWeight: '700' }}>Employee Name</h5>
                    <p className="mb-1" style={{ fontSize: '16px', fontWeight: '400' }}>
                        {props.username}
                    </p>
                </div>
                <div className="col-md-6">
                    <h5 style={{ fontSize: '16px', fontWeight: '700' }}>Employee Oracle ID</h5>
                    <p className="mb-1" style={{ fontSize: '16px', fontWeight: '400' }}>
                        {props.userid}
                    </p>
                </div>
            </div>

            <Divider /> */}

            <h5 className="mt-3" style={{ fontSize: '20px', fontWeight: '600' }}>
            Feature Details
            </h5>

            <div className="row mt-3">
                <div className="col-md-6">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>Feature Type</h5>
                    <Dropdown
                        value={featureType}
                        options={props.featureTypes}
                        onChange={onFeatureTypeChange}
                        optionLabel="name"
                        placeholder="Select Feature Type"
                        className="w-100"
                        style={{ borderRadius: '10px' }}
                    />
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-12">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>Comment</h5>
                    <InputTextarea
                        className="w-100"
                        value={featureRequestComment}
                        onChange={(e) => setFeatureRequestComment(e.target.value)}
                        rows={5}
                        maxLength={4000}
                        style={{ borderRadius: '10px' }}
                    />
                </div>
            </div>
            <div className="featureRequestcharLimit">4,000 Character Limit</div>
            <div> 
                <Button
                label="Submit"
                onClick={Submit}
                disabled={!enableSubmit}
                className="p-button ps-5 pe-5 float-end mt-3"
                style={{ borderRadius: '12px', backgroundColor: '#3299FF', color: 'white'  }}
            />
        </div>
        <div>
                {showLoader && (
                    <div className="divSpinner">
                        <Spinner />
                    </div>
                )}

            </div>
            <Dialog visible={successvisible} modal header={headerSuccessElement} footer={footerSuccessContent} style={{ width: '30rem' }} onHide={setSuccessdialogvisibility} closable={false}>
                <p className="m-0">
                    Thank you for reaching out. Here's your ticket number for your reference <b>{number}</b>
                </p>
            </Dialog>
            <Dialog visible={failvisible} modal header={headerFailElement} footer={footerFailContent} style={{ width: '30rem' }} onHide={setFaildialogvisibility} closable={false}>
                <p className="m-0">
                    {message}
                </p>
            </Dialog>
        </div>
    );
};
